import "@babel/polyfill"
import Vue from 'vue'

// Components
import App from '@/App.vue'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import * as VueGoogleMaps from 'vue2-google-maps'
import FlashMessage from '@smartweb/vue-flash-message';
// Plugins
import Buefy from 'buefy'

import Analytics from '@/plugins/Analytics'
import API from '@/plugins/API'
import Date from '@/plugins/Date'
import Firebase, {checkToken} from '@/plugins/Firebase'
import Firestore from '@/plugins/Firestore'
import Schema from '@/plugins/Schema'

// Router
import router from '@/router'
import guard from '@/router/guard'

// Store
import store from '@/store'

// Styles & Icons
import '@/assets/scss/app.scss'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee, faExpand, faCaretDown, faCaretUp, faProjectDiagram, faLayerGroup, faHandHoldingUsd, faTools, faGolfBall } from '@fortawesome/free-solid-svg-icons'

library.add( faCoffee, faExpand, faCaretDown, faCaretUp, faProjectDiagram, faLayerGroup, faHandHoldingUsd, faTools )

// Sentry
if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: 'https://a9c56759b6c94aa9857adc7fdb21c2ea@sentry.io/1549845',
    integrations: [
      new Integrations.Vue({
        Vue, 
        attachProps: true, 
      })
    ]
  })
}

// Service Worker
// import '@/registerServiceWorker'

// Use Plugins
Vue.use(Buefy, {
  defaultIconPack: 'fas',
  defaultContainerElement: '#app'
})

Vue.use(Analytics)
Vue.use(API)
Vue.use(Date)
Vue.use(Firebase)
Vue.use(Firestore)
Vue.use(Schema)
Vue.use(FlashMessage)
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyC3Jeaf8cMunQGIfeYDoMe8yTStXjc1YDk"
  }
})

// Vue Config
Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV != 'production'

router.beforeEach((to, from, next) => {
  checkToken()
  guard(to, (error:Error, authenticated?:Boolean, permitted?:Boolean) => {
    
    if (error) {
      router.push(`/404?path=${to.path}`)
      return
    }
    
    if (!authenticated) {
      if (!permitted) {
        router.push(to.path == "/" ? "/auth" : `/auth?redirect=${to.path}`)
      } else {
        next()
        return
      }
    } else {
      if (!permitted) {
        if (from) {
          alert("Access denied.")
          router.go(-1)
        }
        router.push('/')
        return
      } else {
        next()
        return
      }
    }

  })
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
